import React from 'react'
import { useHistory } from 'react-router-dom'
import { AiOutlineTwitter } from "react-icons/ai"
import { AiOutlineInstagram } from "react-icons/ai"
import { AiFillLinkedin } from "react-icons/ai"
import badge from "../../../../assets/images/brandpush-trust-badge.png"



import D1 from "../../../../assets/images/adwarve1.jpg"
import D2 from "../../../../assets/images/adwarve2.jpg"
import D3 from "../../../../assets/images/adwarve3.jpg"
import D4 from "../../../../assets/images/adwarve4.jpg"


import "./Team.scss"

const Team = () => {

  const history = useHistory();


  const handleRoute = () => {


    window.open('https://www.marketwatch.com/press-release/angrydwarvestribenft-launches-nft-project-created-from-a-community-of-rug-pull-victims-2022-02-25', '_blank');

  }

  return (
    <>
      <div className="team_container">
        <div className="box">
          <div className="heading">
            <div className="title">
              The team, the family
            </div>
            {/* <div className="detail">
              We are 19 humans 
            </div> */}
          </div>
          <div className="data">
            <div className="mcard">
              <img src={D1} alt="ERROR" />
              <div className="title"> Darren Conway </div>
              <div className="detail"> Project Lead </div>
              <div className="social"><a href='https://www.instagram.com/d.conway1967/' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a>
              </div>
            </div>
            <div className="mcard">
              <img src={D2} alt="ERROR" />
              <div className="title"> Jimmy Merheb </div>
              <div className="detail"> Treasury/Project Council </div>
              <div className="social"> <a href='https://www.linkedin.com/in/jimmy-merheb-271852163' target="_blank" style={{ color: "#0010ee" }}>
                <AiFillLinkedin /></a> </div>
            </div>
            <div className="mcard">
              <img src={D3} alt="ERROR" />
              <div className="title"> Daniel Welter </div>
              <div className="detail"> Treasury/Project Council </div>
              <div className="social"> <a href='https://instagram.com/d._welter?utm_medium=' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a> </div>
            </div>
            <div className="mcard">
              <img src={D4} alt="ERROR" />
              <div className="title"> EBUBECHUKWU-UCHE  </div>
              <div className="detail"> Tresury/Project Council </div>
              <div className="social"> <a href='https://www.instagram.com/bubi_zz/' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a> </div>
            </div>
            <div className="mcard">
              <img src={D2} alt="ERROR" />
              <div className="title"> ChazzaMcnazza </div>
              <div className="detail"> Project Council </div>
              <div className="social"> <a href='https://uk.linkedin.com/in/charlie-mcnally-9814111b5' target="_blank" style={{ color: "#0010ee" }}>
                <AiFillLinkedin /></a> </div>
            </div>
            <div className="mcard">
              <img src={D3} alt="ERROR" />
              <div className="title"> MAVERICK </div>
              <div className="detail"> ADMIN/PROJECT COUNCIL </div>
              <div className="social"> <a href='https://www.instagram.com/mavericks.detailing.wiganuk/' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a>
                <a href='https://www.linkedin.com/in/jp-clarke-27811510a/' target="_blank" style={{ color: "#0010ee" }}>
                  <AiFillLinkedin /></a>
              </div>
            </div>
            <div className="mcard">
              <img src={D4} alt="ERROR" />
              <div className="title"> Clyde Davis  </div>
              <div className="detail"> Project Team </div>
              <div className="social"> <a href='https://www.instagram.com/clydedavis91/' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a>
                <a href='https://twitter.com/mrclydedavis' target="_blank" style={{ color: "#da00ee" }}>
                  <AiOutlineTwitter style={{ color: "blue" }} /></a>

              </div>
            </div>
            <div className="mcard">
              <img src={D1} alt="ERROR" />
              <div className="title"> Bovo  </div>
              <div className="detail"> Social Media Team </div>
              <div className="social"> <a href='https://www.instagram.com/bovo_14/' target="_blank" style={{ color: "#da00ee" }}>
                <AiOutlineInstagram /></a>

              </div>
            </div>
          </div>
        </div>
        {/* <div className='badgediv' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>


          <img className='badgeimg' src={badge} onClick={handleRoute}>
          </img>

        </div> */}
      </div>

    </>
  )
}



export default Team
